// src/services/patientInitials.js
//
// Two-letter initials for the patient avatar on Coordinator cards (UI revamp).
//   "Mike Test"         -> "MT"
//   "Test, Mike"        -> "MT"   ("Last, First" is read as First Last)
//   "Mike James Test"   -> "MT"   (middle names ignored)
//   "Test, Mike James"  -> "MT"
//   "Mike Test Jr."     -> "MT"   (suffixes ignored)
//   "Mike"              -> "M"
//   "" / missing        -> "?"
// Display only; never used for matching.

const SUFFIXES = new Set(["jr", "sr", "ii", "iii", "iv", "v", "md", "phd"]);

const words = (s) =>
  String(s || "")
    .split(/\s+/)
    .map((w) => w.replace(/[^\p{L}\p{N}'-]/gu, ""))
    .filter((w) => w && !SUFFIXES.has(w.toLowerCase().replace(/[.']/g, "")));

const first = (w) => (w ? w.charAt(0).toUpperCase() : "");

export const patientInitials = (name) => {
  const raw = String(name || "").trim();
  if (!raw) return "?";
  let firstName;
  let lastName;
  if (raw.includes(",")) {
    const [last, rest] = raw.split(/,(.*)/s);
    lastName = words(last).slice(-1)[0];
    firstName = words(rest)[0];
  } else {
    const w = words(raw);
    // Already initials (a legacy Sheet row can hold only "MT" or "M.T."): keep them.
    const compact = raw.replace(/\./g, "");
    if (w.length <= 1 && /^[A-Z]{2,3}$/.test(compact)) return compact.charAt(0) + compact.charAt(compact.length - 1);
    firstName = w[0];
    lastName = w.length > 1 ? w[w.length - 1] : "";
  }
  const out = first(firstName) + first(lastName);
  return out || first(words(raw)[0]) || "?";
};
